
import { mdiClose } from "@mdi/js";

export default {
  props: {
    aboutMeText: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,
      mdiClose,
    };
  },

  computed: {
    dialogProps() {
      if (
        this.$device.isMobile ||
        (typeof window !== "undefined" && window.innerWidth < 993)
      ) {
        return {
          scrollable: true,
          transition: "dialog-bottom-transition",
          contentClass: "about-me-dialog__content",
        };
      } else {
        return {
          maxWidth: 860,
          transition: "dialog-transition",
          contentClass: "about-me-dialog__content",
        };
      }
    },
  },

  methods: {
    open() {
      this.isOpen = true;
    },

    close() {
      this.isOpen = false;
    },
  },
};
